import { useFetchUserQuery } from '../services/api/userApi/user';

export function useUser() {
  const userApi = useFetchUserQuery({}, {
    pollingInterval: 1000 * 90, // Poll to sync auth0 params
    skipPollingIfUnfocused: true,
  });

  return userApi;
}
